import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import {middlewareAdapter} from '@homeaway/redux-middleware-adapter';
import reducers from '../reducers';

// Redux DevTools Chrome Extension
// https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd
// https://github.com/zalmoxisus/redux-devtools-extension
const composeEnhancers = composeWithDevTools({
    // Specify here name, actionsBlacklist, actionsCreators and other options if needed
});

export const configureStore = ({initialState = {}} = {}) =>
    createStore(reducers, initialState, composeEnhancers(applyMiddleware(middlewareAdapter, thunk)));

export default configureStore;
